import React, { useCallback, useEffect, useRef, useState } from 'react';
import './AutoSuggestSelect.style.scss';
import Input from '../Input/Input';
import { IOption, IProps as ISelectProps } from '../Select/Select';
import IconButton from '../IconButton/IconButton';

interface IProps extends ISelectProps {
  options: IOption[];
  handleOnChange: (value: ISelectProps['value']) => void;
  testId?: string;
}

const AutoSuggestSelect = (props: IProps) => {
  const { value, options, handleOnChange, testId } = props;
  const [searchValue, setSearchValue] = useState('');

  const handleSearchValueChange = (newSearchValue: string) => {
    setSearchValue(newSearchValue);
  };

  const inputRef = useRef<HTMLInputElement>(null);
  const [filteredOptions, setFilteredOptions] = useState<IOption[]>([]);
  const [focus, setFocus] = useState<boolean>();

  const handleFocus = () => {
    setFocus(true);
  };

  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (focus) {
        const dropdowns = document.getElementsByClassName('suggestion--item');

        let shouldClose = true;

        for (let i = 0; i < dropdowns.length; i++) {
          const openDropdown = dropdowns[i];
          if (openDropdown === event.target) {
            shouldClose = false;
            break;
          }
        }

        if (event.target === inputRef.current) {
          shouldClose = false;
        }

        setFocus(!shouldClose);
      }
    },
    [focus]
  );

  const handleOnClicSuggestion = (newValue: IOption['value'] | undefined) => {
    setSearchValue('');

    setFocus(false);

    handleOnChange(newValue);
  };
  useEffect(() => {
    const currentInputRef = inputRef.current;

    if (inputRef) {
      inputRef.current?.addEventListener('focus', handleFocus);
      window.addEventListener('mousedown', handleClick);
    }

    return () => {
      currentInputRef?.removeEventListener('focus', handleFocus);
      window.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick]);

  useEffect(() => {
    if (searchValue) {
      const newFilteredOptions = options.filter((option) =>
        option.text.toLowerCase().includes(searchValue.toString().toLowerCase())
      );

      setFilteredOptions(newFilteredOptions);
    } else {
      setFilteredOptions(options);
    }
  }, [options, searchValue]);

  return (
    <div tabIndex={10} className="autoSuggestSelect--container">
      {value && (
        <div className="autoSuggestSelect--badge">
          <label>
            {options.find((option) => option.value === value)?.text}
          </label>
          <IconButton
            type="danger"
            icon="close"
            handleOnClick={() => handleOnClicSuggestion(undefined)}
          />
        </div>
      )}

      <Input
        refInput={inputRef}
        value={searchValue}
        handleOnChange={handleSearchValueChange}
        className={value ? 'autoSuggestSelect--hide' : ''}
        data-testid={testId}
      />

      {focus && (
        <div className="suggestions--container ">
          {filteredOptions.map((option) => {
            const handleOnClick = () => {
              handleOnClicSuggestion(option.value);
            };
            return (
              <div
                className="suggestion--item"
                onClick={handleOnClick}
                key={option.value}
              >
                {option.text}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AutoSuggestSelect;
